const C = {
  name: "FinanceTeam",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M13 16.9999H11V8.99994H13V16.9999Z" fill="currentColor"/>
<path d="M6.22159 4.82484C7.91102 3.62871 9.93 2.98633 12 2.98633C14.07 2.98633 16.089 3.62871 17.7784 4.82484C19.4678 6.02097 20.7444 7.7119 21.4321 9.66434C22.1197 11.6168 22.1846 13.7345 21.6176 15.7253C21.2789 16.9145 20.7249 18.0233 19.9898 18.9999H24V20.9999H0V18.9999H4.01022C3.27515 18.0233 2.72107 16.9145 2.38242 15.7253C1.81545 13.7345 1.88026 11.6168 2.56791 9.66434C3.25556 7.7119 4.53216 6.02097 6.22159 4.82484ZM19.6941 15.1775C20.1476 13.5849 20.0958 11.8907 19.5457 10.3287C18.9956 8.76678 17.9743 7.41404 16.6227 6.45713C15.2712 5.50023 13.656 4.98633 12 4.98633C10.344 4.98633 8.72881 5.50023 7.37727 6.45713C6.02573 7.41404 5.00445 8.76678 4.45433 10.3287C3.90421 11.8907 3.85236 13.5849 4.30594 15.1775C4.72814 16.66 5.56889 17.9866 6.72397 18.9999H17.276C18.4311 17.9866 19.2719 16.66 19.6941 15.1775Z" fill="currentColor"/>
</svg>
  `
};
export {
  C as FinanceTeam
};
